import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalSettingsService} from '../../../../services/local-settings.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../services/user-services/user.service';
import {AuthenticationService} from '../../../../services/authentication.service';
import {first, take} from 'rxjs/operators';
import {HubspotService} from '../../../../services/hubspot.service';
import {ProcessService} from '../../../../services/user-services/process.service';
import {AlertService} from '../../../../services/alert.service';
import {document} from 'ngx-bootstrap/utils';
import {Location, NgClass, NgIf} from '@angular/common';
import {PropertiesService} from '../../../../admin/admin-services/properties.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProcessSharedService} from '../../../../services/process-shared.service';
//import {TiktokService} from '../../../../services/tiktok.service';
import {ComponentPendingComponent} from '../components/component-pending/component-pending.component';
import {ComponentInformationsComponent} from '../components/component-informations/component-informations.component';
import {ComponentPaiementComponent} from '../components/component-paiement/component-paiement.component';
import {ProcessNavbarComponent} from '../../../../shared/components/inprocess-layout/process-navbar/process-navbar.component';
import {ComponentBookingInfoComponent} from '../components/component-booking-info/component-booking-info.component';
import {HelperService} from "../../../../services/helper.service";

@Component({
    selector: 'app-step-layout',
    templateUrl: './step-layout.component.html',
    styleUrls: ['./step-layout.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        ComponentBookingInfoComponent,
        ProcessNavbarComponent,
        ComponentPaiementComponent,
        ComponentInformationsComponent,
        ComponentPendingComponent,
        TranslateModule,
    ],
})
export class StepLayoutComponent implements OnInit {

  page: string;
  locale: string;
  booking: any;
  room: any;
  price: number;
  logged: boolean;
  loading: boolean = false;
  isMobile: boolean = false;
  promoCode:string = null;
  iscancel: boolean = false;
  currentLanguage: string;

  // Paiement page
  showNavbar: boolean = false;

  // Cancel booking
  wantCancelBooking:boolean = false;
  hasCancelled: boolean = false;

  // Page informations ( pre-cancel, cancel, pending, validated, refused booking )
  text: any = {
    status: null,
    title: null,
    subtitle: null,
    subtitle2: null,
    p1: null,
    subtitle3: null,
    p2: null,
    p3: null,
    btn1: null,
    btn2: null,
    btn2_text: null,
  }

  // navbar links
  links: any[] = [
    {title: 'COMMON.INFORMATION', link: 'en/accommodation/informations', classes: 'disabled', redirect: false, page: 'informations'},
    {title: 'COMMON.PAYMENT.BASIC', link: 'en/accommodation/payment', classes: 'disabled', redirect: false, page: 'paiement'},
    {title: 'COMMON.CONFIRMATION', link: 'en/accommodation/pending', classes: 'disabled', redirect: false, page: 'pending'},
  ]

  public processes: any[] = [];
  process;
  isRoomAvailable: boolean = true;
  currentUser;
  refuseReason: any;

  constructor(
    private route: ActivatedRoute,
    private localSettings: LocalSettingsService,
    private router: Router,
    private _translateService: TranslateService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private hubspotService: HubspotService,
    private processService: ProcessService,
    private alertService: AlertService,
    private location: Location,
    private careService: PropertiesService,
    private modalService: NgbModal,
    private sharedProcessService: ProcessSharedService,
    //private tikTokService: TiktokService,
    private helperService: HelperService,
  ) {}

  ngOnInit(): void {

    this.localSettings.language$.subscribe(
      (language: string) => {
          this.currentLanguage = language;
      }
  );

    this.route.queryParams.subscribe(params => {
      this.refuseReason = params['refuseReason'];
      if (this.refuseReason) {
        this.setRefuseReason();
      }
    });

    this.currentUser = this.userService.getInfos();
    this.locale = this._translateService.currentLang;
    this.route.data.subscribe((d) => {
      this.localSettings.setSideNavTemplate(d.sidenavTemplate);
      this.localSettings.setPageTitle(d.pageTitle);
      this.page = d.page;
      this.showNavbar = d.showNavBar;
    });
    this.isMobile = this.userService.isMobileUser;

    // Récupère le booking
    this.booking = JSON.parse(localStorage['tempBooking']);
    if (!this.booking) {
      this.goToList();
    } else {
      this.getRoom(this.booking.propId);
    }


    // UTILISATEUR CONNECTE
    if (this.authenticationService.currentUserValue) {
      this.logged = true;
      this.process = this.processService.getProcess('ACCOMMODATION');
      if (this.page === 'paiement') {
        this.processService.createHousingLead(this.booking.propId, 'payment').subscribe();
        const today = new Date();
        this.hubspotService.updateHubspot({date_page_paiement: Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())}).subscribe();
       // this.tikTokService.sendPageView('Url paiement Booking', this.router.url, this.currentUser ? this.currentUser.id : 0, 'paiement page');
      }
    }
    // UTILISATEUR NON CONNECTE
    else {
      if (this.page === 'paiement') {
        this.router.navigate([this.currentLanguage+'/accommodation/informations']);
        //this.tikTokService.sendPageView('URL Pending', this.router.url, this.currentUser ? this.currentUser.id : 0, 'informations page');
      }
    }
    this.hideScrollbar();
    this.setPage();
  }

  getRoom(id) {
    this.sharedProcessService.getRoom(id).pipe(take(1)).subscribe((data) => {
      this.room = data;
      if (this.room) {
        this.price = this.room.property_price.reservation_fees;
        if ((!data.disponibility && this.page === 'paiement') || this.booking.status === 'need_other_room') {
          document.getElementsByClassName('link_container')[0].classList.remove('d-none');
          this.text = {
            status: 'unavailable',
            title: 'PROCESSES.ACCOMMODATION.PAYMENT.UNAVAILABLE_ROOM.TITLE',
            subtitle: null,
            p1: 'PROCESSES.ACCOMMODATION.PAYMENT.UNAVAILABLE_ROOM.TEXT',
            p2: null,
            p3: null,
            btn1: 'dashboard',
            btn2: 'domain',
            btn2_text: 'PROCESSES.ACCOMMODATION.SEE_HOUSING'
          }
        }
      } else {
        this.isRoomAvailable = false;
      }
    });
  }

  goTo() {
    switch (this.text.status) {
      case 'pending' : {
        this.router.navigate(['account/my-profile'], {queryParams: {tab: 'purchase'}});
        break;
      }
      case 'precancel' : {
        this.router.navigate([this.currentLanguage+'/discover']);
        break;
      }
      case 'accepted': {
        this.router.navigate([this.currentLanguage+'/accommodation/post-reservation']);
        break;
      }
      default : {
        this.goToList();
        break;
      }
    }
  }


//----------------------------------- FUNCTIONS

  cancelBooking(statut: string) {
    switch (statut) {
      case 'cancel': {
        this.cancelledProcess();
        break;
      }
      case 'dashboard': {
        this.router.navigate([this.currentLanguage+'/discover']);
        break;
      }

      case 'precancel': {
        this.location.replaceState(this.currentLanguage+'/accommodation/call-an-agent');
        this.preCancelSetting();
        break;
      }

      default: {
        this.location.replaceState(this.currentLanguage+'/accommodation/call-an-agent');
        this.wantCancelBooking = true;
        let hubspotDatas = {
          campagne: '',
          source: '',
          medium: ''
        };
        hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
        this.userService.setHubspotDeal(3321704, 17760779, hubspotDatas).subscribe();
        this.text = {
          status: 'precancel',
          title: 'PROCESSES.ACCOMMODATION.PRE_CANCEL.TITLE',
          subtitle: 'PROCESSES.ACCOMMODATION.PRE_CANCEL.SUBTITLE',
          subtitle2: null,
          p1: 'PROCESSES.ACCOMMODATION.PRE_CANCEL.TEXT_1',
          subtitle3: null,
          p2: 'PROCESSES.ACCOMMODATION.PRE_CANCEL.TEXT_2',
          p3: null,
          btn1: 'cancel',
          btn1_text: 'PROCESSES.ACCOMMODATION.PAYMENT.SUCCESS.CANCEL',
          btn2: 'cancel',
          btn2_text: 'HEADER.DASHBOARD'
        }
        break;
      }
    }
  }

  cancel() {
    let id: number;
    if (this.booking.id) {
      id = this.booking.id;
    } else {
      id = this.booking.booking_id;
    }
    this.processService.cancelBooking(id).subscribe((data) => {
        this.hasCancelled = true;
        if (data['errors'] === 'OK') {
          localStorage.removeItem('tempBooking');
          this.hubspotService.updateHubspot({statut_booking_v2_mail: 'Cancel'}).subscribe();
        } else {
          this.alertService.openSnackBar(data['errors'], 'snack-error');
        }
      },
      (error) => {
        this.alertService.openSnackBar(error, 'snack-error');
      });
  }

  private hideScrollbar(): void {
    if (this.page === 'paiement') {
      document.getElementsByClassName('sidebar')[0].classList.add('d-none');
    } else {
      document.getElementsByClassName('sidebar')[0].classList.remove('d-none');
    }
  }

  private setPage(): void {
    switch (this.page) {
      case 'rejected': {
        localStorage.removeItem('tempBooking');
        this.text = {
          status: 'declined',
          title: 'PROCESSES.ACCOMMODATION.DECLINED.TITLE',
          subtitle: 'PROCESSES.ACCOMMODATION.DECLINED.SUBTITLE',
          subtitle2: this.refuseReason ? 'PROCESSES.ACCOMMODATION.DECLINED.SUBTITLE_2' : null,
          p1: this.refuseReason,
          subtitle3: 'PROCESSES.ACCOMMODATION.DECLINED.SUBTITLE_3',
          p2: 'PROCESSES.ACCOMMODATION.DECLINED.TEXT_1',
          p3: 'PROCESSES.ACCOMMODATION.DECLINED.TEXT_2',
          btn1: 'dashboard',
          btn1_text: 'HEADER.DASHBOARD',
          btn2: 'domain',
          btn2_text: 'PROCESSES.ACCOMMODATION.SEE_HOUSING'
        };
        break;
      }

      case 'refunded': {
        this.cancelledProcess();
        break;
      }

      case 'call-an-agent': {
        this.preCancelSetting();
        break;
      }
    }

  }

  private preCancelSetting(): void {
    this.wantCancelBooking = true;
    this.iscancel = true;
    let hubspotDatas = {
      campagne: '',
      source: '',
      medium: ''
    };
    hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
    this.userService.setHubspotDeal(3321704, 17760779, hubspotDatas).subscribe();
    this.text = {
      status: 'precancel',
      title: 'PROCESSES.ACCOMMODATION.PRE_CANCEL.TITLE',
      subtitle: 'PROCESSES.ACCOMMODATION.PRE_CANCEL.SUBTITLE',
      p1: 'PROCESSES.ACCOMMODATION.PRE_CANCEL.TEXT_1',
      p2: 'PROCESSES.ACCOMMODATION.PRE_CANCEL.TEXT_2',
      p3: null,
      btn1: 'cancel',
      btn1_text: 'COMMON.USER.CANCEL_BOOKING',
      btn2: 'dashboard',
      btn2_text: 'HEADER.DASHBOARD'
    };
  }

  private cancelledProcess(): void {
    let hubspotDatas = {
      campagne: '',
      source: '',
      medium: ''
    };
    hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
    this.userService.setHubspotDeal(3321704, 11333146, hubspotDatas).subscribe();
    this.page = 'Cancelled';
    this.showNavbar = false;
    this.location.replaceState(this.currentLanguage+'/accommodation/refunded');
    this.iscancel = false;
    this.text = {
      status: 'cancel',
      title: 'PROCESSES.ACCOMMODATION.CANCEL.TITLE',
      subtitle: 'PROCESSES.ACCOMMODATION.CANCEL.SUBTITLE',
      subtitle2: null,
      p1: 'PROCESSES.ACCOMMODATION.CANCEL.TEXT_1',
      subtitle3: null,
      p2: null,
      p3: null,
      btn1: 'dashboard',
      btn1_text: 'HEADER.DASHBOARD',
      btn2: 'domain',
      btn2_text: 'PROCESSES.ACCOMMODATION.SEE_HOUSING'
    };
    this.cancel();
  }

  changePage(e) {
    this.page = e;
    this.hideScrollbar();
  }




  public goToList():void {
    this.router.navigate([this.currentLanguage+'/accommodation/list']);
  }

  public closeBooking(modal?){
    if (modal) {
      this.modalService.open(modal, {centered:true,size:'md'})
    } else {
      this.careService.closeBooking(this.booking.id).pipe(first()).subscribe( () => {
        this.alertService.openSnackBar('SNACK.BOOKING.SUCCESSUFULLY_CLOSED', 'snack-success');
        this.modalService.dismissAll();
        this.goToList();
        localStorage.removeItem('bookingEndNotification');
      }, () => {
        this.alertService.openSnackBar('SNACK.BOOKING.ERROR_CLOSED', 'snack-error');
      });
    }

  }

  getCancelStyle(){
    if(!this.iscancel){
      return `btn-default-accommodation`;
    }
    return `btn-danger` + ' ' + 'btn-cancel';
  }

    setRefuseReason() {
      switch(this.refuseReason){
        case '1':
          this.refuseReason = 'COMMON.USER.DECLINED_SHORT';
          break;
        case '2':
          this.refuseReason = 'COMMON.USER.DECLINED_MANY';
          break;
        case '3':
          this.refuseReason = 'COMMON.USER.DECLINED_RISK';
          break;
        case '4':
          this.refuseReason = 'COMMON.USER.DECLINED_TOOEARLY';
          break;
        case '5':
        case '6':
          this.refuseReason = 'COMMON.USER.DECLINED_INDISPO';
          break;
        default:
          this.refuseReason = '';
      }
    }



}
